var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"footer"},[_vm._l((_vm.footers),function(val,key,i){return _c('li',{on:{"click":function($event){return _vm.jump(val)}}},[_vm._v(_vm._s(key))])}),(_vm.copyright && _vm.copyright.copy == 1)?_c('li',{on:{"click":function($event){return _vm.jump(_vm.copyright.outside)}}},[_vm._v(_vm._s(_vm.copyright.copyright))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }